import service from './request'

/**
 * 工单模板列表
 */
 export const orderModelCfgGetList = data => {
  return service({
      showLoading: true,
      url: '/crm/orderModelCfg/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 添加工单模板信息
 */
 export const orderModelCfgAddInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderModelCfg/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 修改工单模板信息
 */
 export const orderModelCfgUpdateInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderModelCfg/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 删除工单模板信息
 */
 export const orderModelCfgDelInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderModelCfg/delInfo',
      method: 'post',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/orderModelCfgManagement.js